// Portfolio Configuration - Centralized customization
export const portfolioConfig = {
  // Personal Information
  personal: {
    name: "Samin Sadik Khan",
    nickname: "SSKsaan",
    title: "Backend-focused Web Developer",
    roles: ["Web Developer", "Problem Solver", "Human like You..."],
    summary: "Backend-focused Web Developer with a problem-solving mindset and experience building fully functional, responsive web applications using Django and core frontend technologies. Built real-world projects from scratch and led programming initiatives and contests within my university. Eager to learn quickly, build meaningful products, and grow in a collaborative team environment.",
    image: "image.webp", 
    resumeUrl: "https://docs.google.com/document/d/1iT9BK8tcGuGPAp9MEdLsy2FTJ1E1AyPI5YfzPNfhjeI/export?format=pdf",
    location: "Dhaka, Bangladesh"
  },

  // Contact Information
  contact: {
    email: "saminsadikkhan@gmail.com",
    phone: "+8801881674502",
    github: "https://github.com/SSKsaan",
    linkedin: "https://www.linkedin.com/in/ssksaan/",
    codeforces: "https://codeforces.com/profile/SSKsan",
    codechef: "https://www.codechef.com/users/ssksan",
    leetcode: "https://leetcode.com/u/SSKsan/"
  },

  // Theme Configuration
  theme: {
    colors: {
      primary: "#06b6d4", // Cyan
      secondary: "#0891b2", // Darker cyan
      accent: "#67e8f9", // Light cyan
      background: "#0f0f23", // Dark background
      surface: "#1e1e3f", // Slightly lighter dark
      text: "#ffffff",
      textSecondary: "#a1a1aa"
    }
  },

  // Tech Stack
  techStack: {
    languages: [
      { name: "Python", icon: "python" },
      { name: "C/C++", icon: "c-plus-plus" },
      { name: "HTML", icon: "html" },
      { name: "CSS", icon: "css" },
      { name: "JavaScript", icon: "javascript" },
      { name: "SQL", icon: "sql" }
    ],
    frameworks: [
      { name: "Django", icon: "django" },
      { name: "Bootstrap", icon: "bootstrap" },
      { name: "TailwindCSS", icon: "tailwind" },
      { name: "Django REST", icon: "django", new: "true" }
    ],
    tools: [
      { name: "VS Code", icon: "vscode" },
      { name: "GitHub", icon: "github" },
      { name: "Notion", icon: "notion" },
      { name: "Canva", icon: "canva" },
      { name: "Google Workspace", icon: "google" },
      { name: "MS Office", icon: "microsoft" }
    ],
    strengths: [
      { name: "Analytical Thinking", icon: "brain" },
      { name: "Attention to Detail", icon: "search" },
      { name: "Peer Mentoring", icon: "users" },
      { name: "Responsive Design", icon: "smartphone" },
      { name: "Clean Presentation", icon: "sparkles" }
    ]
  },

  // Projects
  projects: [
    {
      id: 1,
      name: "Best Khawar Restaurant",
      description: "Django-powered restaurant platform with custom UI, smooth ordering flow, and responsive design.",
      image: "/project-banners/1.webp",
      categories: ["Backend", "Full-Stack"],
      technologies: ["Django", "HTML/CSS", "Bootstrap", "JavaScript"],
      github: "https://github.com/SSKsaan/Restaurant-Project",
      liveDemo: "https://best-khawar-restaurant.onrender.com/",
      demoVideo: "project-videos/1.mp4",
      viewDetails: true
    },
    {
      id: 2,
      name: "SpendinControl",
      description: "A lightweight installable offline-first expense tracker",
      image: "/project-banners/2.png",
      categories: ["MVP"],
      technologies: ["HTML", "CSS", "JavaScript"],
      github: "https://github.com/SSKsaan/SpendinControl",
      liveDemo: "https://ssksaan.github.io/SpendinControl/",
      demoVideo: "project-videos/2.mp4",
      viewDetails: true
    },
    {
      id: 3,
      name: "Unbeatable TicTacToe Game",
      description: "A smart TicTacToe game with AI opponent that never loses.",
      image: "/project-banners/3.png",
      categories: ["Practice"],
      technologies: ["Python", "PyGame"],
      github: "https://github.com/SSKsaan/Python/blob/main/Academic/TicTacToe-Ai-Pygame.py",
      liveDemo: null,
      demoVideo: "project-videos/3.mp4",
      viewDetails: true
    },
    {
      id: 4,
      name: "My first Django REST framework project",
      description: "Bridge between common mass and an essential appointment service, through a paid platform.",
      image: "/project-banners/comingsoon.jpg",
      categories: ["Ongoing", "Backend"],
      technologies: ["Django REST", "HTML/CSS", "TailwindCSS"],
      github: null,
      liveDemo: null,
      demoVideo: null,
      viewDetails: true
    }
  ],

  // Achievements
  achievements: [
    {
      title: "Codeforces Pupil",
      description: "Max Rating 1273",
      link: "https://codeforces.com/profile/SSKsan",
      icon: "cf"
    },
    {
      title: "CodeChef 3★",
      description: "Max Rating 1650",
      link: "https://www.codechef.com/users/ssksan",
      icon: "chef"
    },
    {
      title: "ICPC Dhaka Regionalist 2023",
      description: "Participated in prestigious programming contest",
      link: null,
      icon: "check"
    },
    {
      title: "Programming Contest Awards",
      description: "Multiple winner & runner-up positions in intra-university contests",
      link: null,
      icon: "award"
    }
  ],

  // Education
  education: [
    {
      id: 1,
      institution: "Prime University",
      degree: "BSc in Computer Science & Engineering",
      grade: "CGPA 3.9+",
      year: "2022–2026",
      icon: "graduation-cap"
    },
    {
      id: 2,
      institution: "Dr. Mahbubur Rahman Mollah College",
      degree: "HSC (Science)",
      grade: "GPA 5.0",
      year: "2021",
      icon: "book"
    },
    {
      id: 3,
      institution: "Motijheel Model High School",
      degree: "SSC (Science)",
      grade: "GPA 5.0",
      year: "2019",
      icon: "school"
    }
  ],

  // Navigation
  navigation: [
    { name: "Home", href: "#home", icon: "home" },
    { name: "Skills", href: "#skills", icon: "code" },
    { name: "Projects", href: "#projects", icon: "folder" },
    { name: "Achievements", href: "#achievements", icon: "trophy" },
    { name: "Education", href: "#education", icon: "graduation-cap" },
    { name: "Contact", href: "#contact", icon: "envelope" }
  ]
};

export default portfolioConfig;